<template>
  <div class="flex md:justify-between flex-col-reverse md:flex-row">
    <section class="bg-white p-4 md:p-8 lg:p-10 lg:w-1/3 rounded-lg step">
      <h3 class="lg:text-3xl leading-normal font-semibold">
        Now organize your board journey steps
      </h3>
      <p class="text-lg mt-4 lg:mt-6" style="color: #a8a8a8">
        For things you need to do, add apps and link to your journey steps.
        organize, or invite your employee and student.
      </p>

      <div class="mt-4 lg:mt-6" style="color: #3c3c3c">
        <div class="my-4" v-for="(inputField, i) in inputFields" :key="i">
          <div class="p-4 step-box flex items-center justify-between w-full">
            <div class="text-xl">Step {{ i + 1 }} : {{ inputField.title }}</div>
            <div
              v-if="i !== 0"
              class="btn-trigger text-lg py-1 px-3 rounded-full font-medium cursor-pointer flex items-center"
              @click="
                inputField.colData = {};
                inputField.isStepValid = false;
                triggerAt = triggerAt === i ? -1 : i;
                optionSelected = '';
              "
            >
              <img
                src="@/assets/images/icons/addPlusIcon.svg"
                class="w-6 h-6 mr-2"
                alt="Trigger"
              />
              Trigger
            </div>
          </div>

          <div v-if="inputField.isStepValid">
            <div
              v-if="inputField.colData.appStepData"
              class="flex items-center step-box bg-disabled"
            >
              <vx-tooltip :text="getApp(inputField.colData.appSelected).title">
                <img
                  :src="getApp(inputField.colData.appSelected).icon"
                  class="w-10 h-10 m-2 mr-0"
                  :alt="getApp(inputField.colData.appSelected).title"
                />
              </vx-tooltip>
              <input
                class="w-full p-4 text-xl border-none bg-none"
                :placeholder="
                  getAppFlow(
                    inputField.colData.appSelected,
                    inputField.colData.appStepData
                  ).title
                "
                disabled
              />
            </div>

            <input
              v-else-if="inputField.colData.customLink"
              class="w-full p-4 text-xl"
              :placeholder="inputField.colData.customLink"
              disabled
            />

            <div
              v-if="inputField.colData.socialStepData"
              class="flex items-center step-box bg-disabled"
            >
              <div class="flex items-center cursor-pointer">
                <img
                  :src="
                    require(`@/assets/images/icons/social-icons/${
                      getSocialStepById(inputField.colData.socialStepData)
                        .iconId
                    }.png`)
                  "
                  :alt="
                    getSocialStepById(inputField.colData.socialStepData).title
                  "
                  class="w-6 h-6 ml-4"
                />

                <input
                  class="w-full p-4 text-xl border-transparent"
                  :placeholder="
                    getSocialStepById(inputField.colData.socialStepData).title
                  "
                  disabled
                />
              </div>
            </div>

            <div
              v-if="inputField.colData.web3StepData"
              class="flex items-center step-box bg-disabled"
            >
              <div class="flex items-center cursor-pointer">
                <img
                  :src="
                    require(`@/assets/images/icons/web3-icons/${
                      getWeb3StepById(inputField.colData.web3StepData).iconId
                    }.svg`)
                  "
                  :alt="getWeb3StepById(inputField.colData.web3StepData).title"
                  class="w-6 h-6 ml-4"
                />

                <input
                  class="w-full p-4 text-xl border-transparent"
                  :placeholder="
                    getWeb3StepById(inputField.colData.web3StepData).title
                  "
                  disabled
                />
              </div>
            </div>
          </div>

          <div class="mb-4 relative" v-if="triggerAt === i">
            <div
              class="options-container relative rounded-lg"
              v-if="!optionSelected"
            >
              <div class="options flex flex-wrap text-center m-0 relative">
                <div
                  class="flex flex-col items-center justify-center py-8 cursor-pointer"
                  v-for="(option, i) in options"
                  :key="i"
                  @click="selectStepOptionType(option)"
                >
                  <span class="relative z-10">
                    <img :src="option.icon" :alt="option.name" />
                    <!-- class="card-img-top w-1/5 h-1/5 lg:w-2/5 lg:h-2/5" -->
                    <!-- <feather-icon
                      :icon="`${option.icon}Icon`"
                      svgClasses="w-10 h-10 text-grey"
                    /> -->
                    <p class="mt-2 font-medium">{{ option.name }}</p>
                  </span>
                </div>
              </div>
            </div>

            <div v-if="optionSelected === 'customLink'">
              <div class="flex items-center justify-between step-box">
                <input
                  class="w-full p-4 text-xl border-none"
                  placeholder="https://example.link.com"
                  v-model="customLink"
                  @blur="pushLink(triggerAt)"
                />
                <!-- <div class="pr-4 flex">
                  <img
                    @click="pushLink(triggerAt)"
                    src="@/assets/images/icons/green-tick.svg"
                    class="cursor-pointer w-6 h-6"
                    alt="Tick"
                  />
                </div> -->
              </div>
              <p
                v-if="!isCustomLinkValid && isCustomLinkValid"
                class="text-lg font-normal error-text mt-1"
              >
                Please enter a valid URL
              </p>
            </div>

            <div v-if="appStepChosen">
              <input
                class="w-full p-4 text-xl"
                placeholder="Select step"
                v-model="appStepChosen.title"
              />
              <!-- <p v-if="!customLink" class="text-lg font-normal error-text mt-1">
                Enter step name
              </p> -->
            </div>

            <div v-if="optionSelected === 'selectApps' && !appStepChosen">
              <vue-perfect-scrollbar
                v-if="!appSelected"
                class="step-box p-2 px-4 flex flex-col gap-2 overflow-y-scroll bg-white absolute z-50 w-full"
              >
                <div v-for="(app, i) in apps" :key="i">
                  <div
                    class="flex items-center cursor-pointer"
                    @click="
                      appSelected = app.id;
                      inputFields[triggerAt].colData.appSelected = app.id;
                    "
                  >
                    <img :src="app.icon" class="w-12 h-12" :alt="app.title" />
                    <div class="flex flex-col text-left">
                      <span class="text-lg font-semibold ml-2 text-left">
                        {{ app.title }}
                      </span>
                      <span class="text-lg ml-2">
                        {{ app.pricePerUser }} per user
                      </span>
                    </div>
                  </div>
                </div>
              </vue-perfect-scrollbar>

              <vue-perfect-scrollbar
                v-if="appSelected"
                class="step-box p-2 px-4 flex flex-col gap-2 overflow-y-scroll bg-white absolute z-50 w-full"
              >
                <div
                  v-for="(appStep, i) in appFlow.flow[appSelected].steps"
                  :key="i"
                  v-show="appStep.id !== 'appInstalled'"
                >
                  <div class="flex items-center justify-between cursor-pointer">
                    <span class="text-lg font-semibold ml-2 text-left">
                      {{ appStep.title }}
                    </span>
                    <vs-radio
                      :color="orgData.primaryThemeColor"
                      v-model="inputFields[triggerAt].colData.appStepData"
                      :vs-value="appStep.id"
                      :vs-name="appStep.id"
                      @change.native="
                        inputFields[triggerAt].isStepValid = true;
                        triggerAt = -1;
                      "
                    />
                  </div>
                </div>
              </vue-perfect-scrollbar>

              <!-- <p v-if="!customLink" class="text-lg font-normal error-text mt-1">
                Enter step name
              </p> -->
            </div>

            <div v-if="optionSelected === 'connectSocials'">
              <vue-perfect-scrollbar
                class="step-box p-2 px-4 flex flex-col gap-2 overflow-y-scroll bg-white absolute z-50 w-full"
              >
                <div v-for="(socialStep, i) in connectSocialSteps" :key="i">
                  <div class="flex items-center justify-between cursor-pointer">
                    <div class="flex items-center gap-x-2">
                      <img
                        :src="
                          require(`@/assets/images/icons/social-icons/${socialStep.iconId}.png`)
                        "
                        :alt="socialStep.title"
                        class="w-6 h-6"
                      />
                      <span class="text-lg font-semibold ml-2 text-left">
                        {{ socialStep.title }}
                      </span>
                    </div>
                    <vs-radio
                      :color="orgData.primaryThemeColor"
                      v-model="inputFields[triggerAt].colData.socialStepData"
                      :vs-value="socialStep.id"
                      :vs-name="socialStep.id"
                      @change.native="
                        inputFields[triggerAt].isStepValid = true;
                        triggerAt = -1;
                        inputFields[triggerAt].colData = {};
                      "
                    />
                  </div>
                </div>
              </vue-perfect-scrollbar>
            </div>

            <div v-if="optionSelected === 'web3'">
              <vue-perfect-scrollbar
                class="step-box p-2 px-4 flex flex-col gap-2 overflow-y-scroll bg-white absolute z-50 w-full"
              >
                <div v-for="(web3Step, i) in web3Steps" :key="i">
                  <div class="flex items-center justify-between cursor-pointer">
                    <div class="flex items-center gap-x-2">
                      <img
                        :src="
                          require(`@/assets/images/icons/web3-icons/wallet-icon.svg`)
                        "
                        :alt="web3Step.title"
                        class="w-6 h-6"
                      />
                      <span class="text-lg font-semibold ml-2 text-left">
                        {{ web3Step.title }}
                      </span>
                    </div>
                    <vs-radio
                      :color="orgData.primaryThemeColor"
                      v-model="inputFields[triggerAt].colData.web3StepData"
                      :vs-value="web3Step.id"
                      :vs-name="web3Step.id"
                      @change.native="
                        inputFields[triggerAt].isStepValid = true;
                        triggerAt = -1;
                        inputFields[triggerAt].colData = {};
                      "
                    />
                  </div>
                </div>
              </vue-perfect-scrollbar>
            </div>
          </div>

          <p
            v-if="missingStepTriggerAt === i"
            class="text-lg font-normal error-text mt-1"
          >
            Select step action
          </p>
        </div>

        <vs-button
          class="w-1/3 rounded-lg text-xl mt-4"
          @click="routeToStepFour"
          :color="orgData.primaryThemeColor"
          >Next</vs-button
        >
      </div>

      <div class="mt-6 flex justify-between">
        <p
          class="flex items-center text-lg md:text-xl cursor-pointer"
          style="color: #a8a8a8"
          @click="
            $router.push(
              `/organization/${orgData.slug}/create-board/${$route.params.boardId}/step2`
            )
          "
        >
          <img src="@/assets/images/icons/arrow-left-grey.svg" alt="Back" />
          Back
        </p>
        <p class="text-lg md:text-xl cursor-pointer" style="color: #a8a8a8">
          Skip
        </p>
      </div>
    </section>

    <section
      class="mb-6 md:mb-0 md:ml-8 bg-white p-4 md:p-8 lg:p-10 lg:w-2/3 rounded-lg step"
    >
      <BoardSkeletonVue />
    </section>
  </div>
</template>

<script>
import BoardSkeletonVue from "./component/BoardSkeleton.vue";
import appFlow from "@/assets/data/app-flow.js";
import apps from "@/assets/data/marketplace-list.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import commonMixin from "./mixins/commonMixin";
import { connectSocialSteps, web3Steps } from "@/assets/data/journeySteps.js";

export default {
  data() {
    return {
      appFlow,
      connectSocialSteps,
      web3Steps,
      apps,
      inputFields: [],
      missingStepTriggerAt: -1,
      options: [
        {
          icon: require("@/assets/images/boards/icons/link.svg"),
          name: "Custom Link",
          actionType: "customLink",
          id: "customLink",
        },
        // {
        //   icon: require("@/assets/images/boards/icons/form.svg"),
        //   name: "Form",
        //   actionType: "openForm",
        // },
        {
          icon: require("@/assets/images/boards/icons/social.svg"),
          name: "Social",
          actionType: "connectSocials",
          id: "socialConnections",
        },
        // {
        //   icon: require("@/assets/images/boards/icons/web3.svg"),
        //   name: "Web3",
        //   actionType: "web3",
        //   id: "web3",
        // },
        // {
        //   icon: require("@/assets/images/boards/icons/integration.svg"),
        //   name: "Integration",
        //   actionType: "",
        //   id: "",
        // },
        {
          icon: require("@/assets/images/boards/icons/apps.svg"),
          name: "Apps",
          actionType: "selectApps",
          id: "apps",
        },
      ],
      optionSelected: "",
      triggerAt: -1,
      appSelected: "",
      appStepChosen: false,
      customLink: "",
      isCustomLinkValid: true,
      installApps: [],
    };
  },
  components: {
    BoardSkeletonVue,
    VuePerfectScrollbar,
  },
  mixins: [commonMixin],
  watch: {
    optionSelected: {
      handler(newVal) {
        if (!newVal) {
          this.appSelected = "";
          this.appStepChosen = false;
        }
      },
      immediate: true,
      deep: true,
    },
    kanbanData: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.cols) {
          this.inputFields = newVal.cols.map((field) => {
            const { title, colData } = field;
            return {
              title: title,
              placeHolder: title,
              colData: colData ? colData : {},
              isStepValid: colData && colData.type ? true : false,
            };
          });
          // this.validateStepName();
        }
      },
    },
  },
  mounted() {
    this.getKanbanBoardDetails(this.$route.params.boardId);
  },
  methods: {
    validateStepName() {
      for (let i = 1; i < this.inputFields.length; i++) {
        if (this.inputFields[i].colData && this.inputFields[i].isStepValid) {
          this.missingStepTriggerAt = -1;
        }
      }
    },
    routeToStepFour() {
      this.validateStepName();
      this.installApps = [];
      if (this.missingStepTriggerAt === -1) {
        let boardId = this.$route.params.boardId;
        let apps = this.inputFields.map(m=> m.colData.appSelected);
        this.installApps = apps.filter(a=>a!==undefined);
        console.log("your install apps are", this.installApps);
        this.$store
                  .dispatch("boards/updateBoard", {
                    boardObj: {
                      installedApps: this.installApps, 
                      _boardId: boardId,
                    },
                    organizationId: this.orgData._id,
                  })
                  .then((res) => {
                    if (res && res.data && res.data._id) {
                     
                    }
                    console.log(res);
                  })
                  .catch((err) => {
                    throw err;
                  });
        this.$store
          .dispatch("kanban/updateKanbanV2", {
            boardId: boardId,
            cols: this.inputFields,
          })
          .then((res) => {
            if (res && res.data && res.data.data && res.data.data._id) {
              this.$router.push(
                `/organization/${this.orgData.slug}/create-board/${boardId}/step4`
              );
            }
          })
          .catch((err) => {
            throw err;
          });
      }
    },
    getKanbanBoardDetails(boardId) {
      this.$store.dispatch("kanban/getKanbanDataV2", boardId);
    },
    selectStepOptionType(option) {
      this.optionSelected = option.actionType;
      this.inputFields[this.triggerAt].colData.type = option.id;
    },
    pushLink(activeIndex) {
      const urlPattern = /\b((https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}([\/?].*)?)\b/;
      this.isCustomLinkValid = urlPattern.test(this.customLink);
      if (this.isCustomLinkValid) {
        this.inputFields[activeIndex].colData = {};
        this.inputFields[activeIndex].colData = {
          type: "customLink",
          customLink: this.customLink,
        };
        this.inputFields[activeIndex].isStepValid = true;
        this.customLink = "";
        this.triggerAt = -1;
      }
    },
    getApp(id) {
      return apps.find((app) => app.id === id);
    },
    getAppFlow(appId, appStepId) {
      return this.appFlow.flow[appId].steps.find(
        (step) => step.id === appStepId
      );
    },
    getSocialStepById(id) {
      return this.connectSocialSteps.find((step) => step.id === id);
    },
    getWeb3StepById(id) {
      return this.web3Steps.find((step) => step.id === id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./styles/step-common.scss";

.addField {
  border-radius: 12px;
  border: 2px solid #e8ebed;
  color: #a8a8a8;
}

.options-container {
  border: 2px solid #e8ebed;
}

.ps-container {
  max-height: 12rem;
  height: max-content;
}

.options {
  &:before {
    position: absolute;
    content: "";
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: -webkit-linear-gradient(
      left,
      #fff 0%,
      rgba(255, 255, 255, 0) 50%,
      #fff 100%
    );
    background-image: linear-gradient(
      to right,
      #fff 0%,
      rgba(255, 255, 255, 0) 50%,
      #fff 100%
    );
    z-index: 1;
  }

  &:after {
    position: absolute;
    content: "";
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: -webkit-linear-gradient(
      bottom,
      #fff 0%,
      rgba(255, 255, 255, 0) 50%,
      #fff 100%
    );
    background-image: linear-gradient(
      to top,
      #fff 0%,
      rgba(255, 255, 255, 0) 50%,
      #fff 100%
    );
    z-index: 1;
  }

  div {
    width: 33.33%;
    position: relative;
    background-color: #fff;
    padding: 40px 0;
    &:before {
      position: absolute;
      content: "";
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      border-right: 1px solid #bcbbbb;
      border-bottom: 1px solid #bcbbbb;
    }
  }
}
</style>
